export default "__VITE_ASSET__DxBCcD3L__"